import {
  MISINFORMES_SUCCESS,
  MISINFORMES_LOADING,
  MISINFORMES_ERROR,
  MISINFORMES_RESET,
  MISINFORMES_ARCHIVOBASE64,
  MISINFORMES_VISUALIZARIMAGEN,
  MISINFORMES_RESET_VISUALIZARIMAGEN,
  MISINFORMES_RESET_ARCHIVOBASE64,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";
import misInformesInitialState from "../initialStates/misInformesInitialState";

const misInformes = (state, { payload, type }) => {
  switch (type) {
    case MISINFORMES_LOADING:
      return {
        ...state,
        misInformes: {
          ...state.misInformes,
          error: false,
          loading: true,
        },
      };
    case MISINFORMES_SUCCESS:
      return {
        ...state,
        misInformes: {
          ...state.misInformes,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case MISINFORMES_ERROR:
      return {
        ...state,
        misInformes: {
          ...state.misInformes,
          error: payload,
          loading: false,
        },
      };
    case MISINFORMES_ARCHIVOBASE64:
      return {
        ...state,
        misInformes: {
          ...state.misInformes,
          loading: false,
          error: false,
          archivobase64: payload,
        },
      };
    case MISINFORMES_VISUALIZARIMAGEN:
      return {
        ...state,
        misInformes: {
          ...state.misInformes,
          loading: false,
          error: false,
          visualizarimagen: payload,
        },
      };
    case MISINFORMES_RESET_VISUALIZARIMAGEN:
      return {
        ...state,
        misInformes: {
          ...state.misInformes,
          loading: false,
          error: false,
          visualizarimagen: null,
        },
      };
    case MISINFORMES_RESET_ARCHIVOBASE64:
      return {
        ...state,
        misInformes: {
          ...state.misInformes,
          loading: false,
          error: false,
          archivobase64: null,
        },
      };

    case MISINFORMES_RESET:
      return misInformesInitialState;
    case RESET_PORTAL_CONTEXT:
      return misInformesInitialState;

    default:
      return state;
  }
};

export default misInformes;
